import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import {ResetPasswordService} from './reset-password.service';
const swal = require('sweetalert');

@Component({
    selector: 'app-recover',
    templateUrl: './recover.component.html',
    styleUrls: ['./recover.component.scss'],
    providers: [ResetPasswordService]
})
export class RecoverComponent implements OnInit {

    mailSent = false;
    recForm: FormGroup;

    constructor(fb: FormBuilder, private resetPasswordService: ResetPasswordService) {

        this.recForm = fb.group({
            'email': [null, Validators.compose([Validators.required, CustomValidators.email])]
        });
    }

    submitForm($ev, form: FormGroup) {
        $ev.preventDefault();
        let value = form.value;
        console.log(value)
        for (let c in form.controls) {
            form.controls[c].markAsTouched();
        }
        if (form.valid) {
            this.resetPasswordService.reset(value).subscribe({
              next: () => {
                this.mailSent = true;
              },
              error: () => {
                this.mailSent = false;
                swal('', 'An error occurred.Please contact our support team.', 'error');
              },
            });
        }
        // console.log(value);
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/routes/user/recover/recover.component.ts